import React from 'react';
import PropTypes from 'prop-types';
//ICONS
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

/**
 * Muestra iconos dependiendo del estado de la propiedad `swap`.
 *
 * Cualquier otra propiedad no especificada en la documentacion sera reenviada al componente [Icon](https://material-ui.com/api/icon/).
 */
function IconSwap({swap, IconSwap, Icon, ...other}) {
   if (swap) {
      return <IconSwap {...other} />;
   }
   return <Icon {...other} />;
}

IconSwap.propTypes = {
   /**
    * Si es __true__ el icon a mostrar sera el proporcionado por la propiedad `IconSwap`, caso contrario se mostrara el icono proporcionado por la propiedad `Icon`.
    */
   swap: PropTypes.bool,
   /**
    * Icono a mostrar cuando `swap` es __false__, default: @material-ui/icons/ExpandMore
    */
   Icon: PropTypes.elementType,
   /**
    * Icono a mostrar cuando `swap` es __true__, default: @material-ui/icons/ExpandLess
    */
   IconSwap: PropTypes.elementType
};
IconSwap.defaultProps = {
   swap: false,
   Icon: ExpandMore,
   IconSwap: ExpandLess
};
export default IconSwap;
